<script>
export default {
  data() {
    return {
      attributes: [
        {
          key: "today",
          highlight: true,
          dates: new Date(),
        },
      ],
      SelctCountry: ["Select Country", "US", "UK"],
      SelctState: ["Select State", "Tornoto", "Texas"],
      SelctCountry: ["Select Country", "US", "UK"],
    };
  },
};
</script>
<template>
  <layout-header></layout-header>
  <div class="page-wrapper">
    <div class="content">
      <div class="container">
        <div class="row">
          <!-- Booking -->
          <div class="col-lg-12">
            <!-- Booking Step -->
            <ul class="step-register row">
              <li class="active col-md-4">
                <div class="multi-step-icon">
                  <img src="@/assets/img/icons/calendar-icon.svg" alt="img" />
                </div>
                <div class="multi-step-info">
                  <h6>Appointment</h6>
                  <p>Choose time & date for the service</p>
                </div>
              </li>
              <li class="col-md-4">
                <div class="multi-step-icon">
                  <img src="@/assets/img/icons/wallet-icon.svg" alt="img" />
                </div>
                <div class="multi-step-info">
                  <h6>Payment</h6>
                  <p>Select Payment Gateway</p>
                </div>
              </li>
              <li class="col-md-4">
                <div class="multi-step-icon">
                  <img src="@/assets/img/icons/book-done.svg" alt="img" />
                </div>
                <div class="multi-step-info">
                  <h6>Done</h6>
                  <p>Completion of Booking</p>
                </div>
              </li>
            </ul>

            <!-- /Booking Step -->

            <!-- Appointment -->
            <div class="booking-service card shadow-none">
              <div class="card-body">
                <div class="row align-items-center">
                  <div class="col-lg-5">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 service-img me-3">
                        <img src="@/assets/img/services/service-27.jpg" alt="img" />
                      </div>
                      <div class="serv-profile">
                        <span class="badge badge-soft-primary">Car Wash</span>
                        <h5 class="my-2">Car Repair Services</h5>
                        <div class="d-flex align-items-center">
                          <span class="avatar avatar-md rounded-circle me-2"
                            ><img
                              src="@/assets/img/profiles/avatar-01.jpg"
                              class="rounded-circle"
                              alt="img"
                          /></span>
                          <div class="serv-pro-info">
                            <h6 class="fs-14 fw-medium">Thomas Herzberg</h6>
                            <p class="serv-review">
                              <i class="fa-solid fa-star"></i> <span>4.9 </span>(255
                              reviews)
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="">
                          <div class="provide-box d-flex align-items-center mb-3">
                            <span class="me-2"><i class="feather-phone"></i></span>
                            <div class="provide-info">
                              <h6 class="fs-14 fw-medium mb-1">Phone</h6>
                              <p>+1 888 888 8888</p>
                            </div>
                          </div>
                          <div class="provide-box d-flex align-items-center">
                            <span class="me-2"><i class="feather-mail"></i></span>
                            <div class="provide-info">
                              <h6 class="fs-14 fw-medium mb-1">Email</h6>
                              <p>thomas@example.com</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="">
                          <div class="provide-box d-flex align-items-center mb-3">
                            <span class="me-2"><i class="feather-map-pin"></i></span>
                            <div class="provide-info">
                              <h6 class="fs-14 fw-medium mb-1">Address</h6>
                              <p>Hanover, Maryland</p>
                            </div>
                          </div>
                          <div class="provide-box d-flex align-items-center">
                            <span class="me-2"><i class="ti ti-wallet"></i></span>
                            <div class="provide-info">
                              <h6 class="fs-14 fw-medium mb-1">Service Amount</h6>
                              <h5>$150.00</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2">
                    <div class="d-flex align-items-center social">
                      <a
                        href="javascript:void(0);"
                        class="d-flex align-items-center justify-content-center"
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="book-form border-top border-bottom pt-4 pb-2">
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">City</label>
                    <vue-select
                      :options="SelcCity"
                      id="selccity"
                      placeholder="Select City"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">State</label>
                    <vue-select
                      :options="SelctState"
                      id="selctstate"
                      placeholder="Select State"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Country</label>
                    <vue-select
                      :options="SelctCountry"
                      id="selctcountry"
                      placeholder="Select Country"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- /Appointment -->

            <!-- Appointment Date & Time -->
            <div class="row">
              <div class="col-lg-4">
                <div class="book-title">
                  <h5>Appointment Date</h5>
                </div>
                <div class="card">
                  <div class="card-body p-2 pt-3">
                    <div id="datetimepickershow">
                      <v-calendar :attributes="attributes" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-8">
                <div class="row">
                  <div class="col-md-12">
                    <div class="book-title">
                      <h5>Appointment Time</h5>
                    </div>
                  </div>
                </div>
                <div class="token-slot mt-2">
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">09.00 AM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">09.30 AM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">10.00 AM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">10.30 AM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">11.00 AM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">11.30 AM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">12.00 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">12.30 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">01.00 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">01.30 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">02.00 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">02.30 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">03.00 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">03.30 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">04.00 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">04.30 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">05.00 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">05.30 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">06.00 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">06.30 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">07.00 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">07.30 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">08.00 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">08.30 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">09.00 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">09.30 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">10.00 PM</span>
                    </label>
                  </div>
                  <div class="form-check-inline visits me-0">
                    <label class="visit-btns">
                      <input type="radio" class="form-check-input" name="appintment" />
                      <span class="visit-rsn">10.30 PM</span>
                    </label>
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-end mt-4">
                  <a href="javascript:void(0);" class="btn btn-light me-2">Cancel</a>
                  <router-link to="/booking/booking-payment" class="btn btn-dark">Book Appointment</router-link>
                </div>
              </div>
            </div>
            <!-- /Appointment Date & Time -->
          </div>
          <!-- /Booking -->
        </div>
      </div>
    </div>
  </div>
  <pages-footer></pages-footer>
</template>
